import React from "react";
import musical1 from "../../../images/musical1.jpg";
import musical2 from "../../../images/musical2.jpg";
import musical3 from "../../../images/musical3.jpg";
import EngagementCarouselPage from "../../ui/EngagementCarouselPage";

const Musical = () => (
  <EngagementCarouselPage
    title="Musical for Fund-raising"
    paragraphs={[
      "On 21st December 2019, A Bollywood Musical by singers was organised to raise funds for a greater kind cause – A Kindness Unlimited sponsored Wheelchair match in February 2020. Thanks to Musical Harmony Group for a very memorable evening that was fulfilled with incredible songs and music by the talented team of singers. The Joy was doubled as they helped us raise funds for the cause of Maharashtra Wheel Chair Cricket. RJ Pari Verma rocked the house with her Kindness and Nisha Gupta & the cricket team inspired all the people present with their positive vibes and abilities. A perfect KUL Evening!",
    ]}
    images={[musical1, musical2, musical3]}
  />
);

export default Musical;
